/**
 * @file Patient detail adapter contract.
 */

import {
    attachPatientDetailActionListeners,
    getPatientDetailFields,
    renderPatientLabsSection,
    setupPatientDetailPeopleControls,
    setupPatientDetailScalarControls,
    setupPatientDetailTypeControls,
} from './patientDetails.js';

/**
 * Detail adapter for Patient parent items.
 */
export const patientDetailAdapter = {
    itemType: 'patient',
    viewName: 'patients',
    statusConfigKey: 'patientStatus',
    typeConfigKey: 'patientTypes',
    validateEmptyTypesOnClear: true,
    liveSaveFields: [
        'priority',
        'provider',
        'status',
        'types',
    ],
    sections: [
        'patientLabs',
        'linkedTasks',
        'checklist',
        'notes',
        'attachments',
    ],
    renderFields: getPatientDetailFields,
    renderSection(sectionId, item) {
        if (sectionId === 'patientLabs') {
            return renderPatientLabsSection(item);
        }
        return null;
    },
    mountControls(detailsViewContainer, item) {
        setupPatientDetailScalarControls(detailsViewContainer, item);
        setupPatientDetailTypeControls(detailsViewContainer, item);
        setupPatientDetailPeopleControls(detailsViewContainer, item);
    },
    attachPostFormListeners(detailsViewContainer, item, context) {
        attachPatientDetailActionListeners(detailsViewContainer, item, context);
    },
    getBackNavigation() {
        return { type: 'view', view: 'patients' };
    },
    getDeleteNavigation() {
        return { type: 'view', view: 'patients' };
    },
};
